















import {
  computed,
  defineNuxtComponent,
  vue3Model
} from '~/utils/nuxt3-migration'
import CLink from '~/components/shared/configurable/link/CLink.vue'
import CIcon from '~/components/shared/configurable/CIcon.vue'
import { resolveCategory } from '~/utils/category'
import { categoriesIconsMappings } from '~/constants/category/icon'
import { CategoryId } from '~/models/category/types'
import { ciThreeDots } from '~/icons/source/thin/three-dots'

export default defineNuxtComponent({
  model: vue3Model,
  components: {
    CLink,
    CIcon
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const categories = computed(() => {
      return props.modelValue.searchables || []
    })

    function getCategoryIcon(categoryId: CategoryId) {
      return (
        resolveCategory(categoriesIconsMappings, [categoryId]) || ciThreeDots
      )
    }

    return {
      categories,
      getCategoryIcon
    }
  }
})
